"use strict";

var UserSelectFilterActions = require("app/screens/Activity/actions/user-select-filter-actions");
var UserSelectFilterStore = require("app/screens/Activity/stores/user-select-filter-store");
var Dropdown = require("app/shared/components/Dropdown/dropdown");
var ActivitiesCount = require("./activities-count");
var _ = require("underscore");

var UserSelectFilter = React.createClass({
  mixins: [Reflux.ListenerMixin],
  getInitialState: function() {
    var initialState = UserSelectFilterStore.state;
    initialState.selectedId = this.props.filters ? this.props.filters.userId : null;
    return initialState;
  },
  getDefaultProps: function() {
    return { loggedUserId: window.loggedUserId, showLabel: true };
  },
  componentDidMount: function(){
    this.listenTo(UserSelectFilterStore, this.setState);
    UserSelectFilterActions.loadUsers();
  },
  handleChange: function(obj) {
    this.props.setFilter("userId", obj.value);
    var user = _.find(this.state.users, function (user) {
      return user.id == obj.value;
    });
    this.props.setFilter("offset", 0, true);
    this.props.setFilter("userName", (user? user.name : null));
    this.setState({
      selectedId: obj.value
    });
  },
  getOptions: function() {
    var loggedUserName = this.props.showLabel ? "Mim" : "Eu";
    var defaultOptionLabel = this.props.defaultOptionLabel || "Todos";

    var options = _.map(this.state.users, function(user){
      if (this.props.loggedUserId == user.id) {
        return {id: user.id, name: loggedUserName, group: "nogroup"};
      }
      return {id: user.id, name: user.name, group: (user.active ? "active" : "inactive")};
    }.bind(this));
    options = _.sortBy(options, "name");
    options.push({id: "", name: defaultOptionLabel, group: "nogroup"});

    return options;
  },
  render: function() {
    let activeLabel = (window && window.loggedUserIsAdmin == "1") ? "Ativos" : "Usuários";
    var groupingOptions = [
      { id: "nogroup", name: "" },
      { id: "active", name: activeLabel },
      { id: "inactive", name: "Inativos" }
    ];
    var options = this.getOptions();

    return(
      <div className={`userSelect-filter fs-14 ${this.props.className}`}>
        {this.props.showLabel &&
          <span className="filter-label hidden-md">
            <ActivitiesCount count={this.props.totalActivitiesCount} pending={this.props.filters.pending} />
          </span>
        }
        <div className="d-ib">
          <Dropdown ref="user" handleCustomChange={this.handleChange} value={this.state.selectedId}
            options={options} groups={groupingOptions} className="w-120 b-light"/>
        </div>
      </div>
    );
  }
});

module.exports = UserSelectFilter;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/ActivityList/user-select-filter.jsx